import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject, resource, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { IBbitWebShopDocument } from '@bbitgmbh/bbit.utils';
import {
  BbitWebShopApiService,
  BbitWebShopCartService,
  BbitWebShopFormatPricePipe,
  BbitWebShopService,
  BbitWebShopVatCalculationMethod,
} from '@bbitgmbh/webshop.sdk';
import { I18nPipe, LuxonPipe } from '@bbitgmbh/website.sdk';
import { LoadingComponent } from '../../helper/loading/loading.component';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
  imports: [RouterLink, NgTemplateOutlet, AsyncPipe, I18nPipe, LuxonPipe, BbitWebShopFormatPricePipe, LoadingComponent],
})
export class DocumentComponent {
  public VatCalculationMethod = BbitWebShopVatCalculationMethod;
  public bucket = signal('');
  public id = signal('');
  public webShop = inject(BbitWebShopService);
  public api = inject(BbitWebShopApiService);
  public cart = inject(BbitWebShopCartService);

  public data = resource<IBbitWebShopDocument, { bucket: string; id: string }>({
    params: () => {
      return { id: this.id(), bucket: this.bucket() };
    },
    loader: async ({ params }) => {
      if (!params.bucket) {
        throw new Error('Bucket is missing');
      }
      if (!params.id) {
        throw new Error('Id is missing');
      }
      return this.api.getDocument(params.bucket, params.id);
    },
  });

  constructor(private _activatedRoute: ActivatedRoute) {
    this._activatedRoute.params.pipe(takeUntilDestroyed()).subscribe(async (params) => {
      this.bucket.set(params['_bucket']);
      this.id.set(params['_id']);
    });
  }
}
